module.exports = __webpack_public_path__ + "img/IMG_0341.3f98d7ce.png";